import Controller from '@ember/controller';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type StoreService from 'scaleflow/services/store';
import type BetaToggleService from 'scaleflow/services/beta-toggle';
import type IntlService from 'ember-intl/services/intl';
import type DepartmentModel from 'scaleflow/models/department';
import type GoalModel from 'scaleflow/models/goal';

export default class CompanyDepartmentGoalsController extends Controller {
  @service declare store: StoreService;
  @service declare betaToggle: BetaToggleService;
  @service declare intl: IntlService;

  declare model: DepartmentModel;

  queryParams = ['search', 'status', 'initiativesLinked'];
  @tracked search = '';
  @tracked status: boolean[] = [];
  @tracked initiativesLinked: boolean[] = [];

  get sortedGoals(): GoalModel[] {
    return this.model.sortedGoals;
  }

  get goals() {
    let goals = this.sortedGoals;
    if (this.status.length === 0 && !this.initiativesLinked) {
      return goals;
    }

    if (this.status.length !== 0) {
      goals = goals.filter((goal) => this.status.includes(goal.active));
    }
    if (this.initiativesLinked.length !== 0) {
      goals = goals.filter((goal) =>
        this.initiativesLinked.includes(goal.initiatives.length > 0),
      );
    }
    return goals;
  }

  get trueFalseOptions() {
    return [
      {
        label: this.intl.t('dictionary.yes'),
        value: true,
      },
      {
        label: this.intl.t('dictionary.no'),
        value: false,
      },
    ];
  }

  get isAMatchCallback() {
    if (!this.search) return () => true;
    return (goal: GoalModel) => {
      return goal.title.toLowerCase().includes(this.search.toLowerCase());
    };
  }
}
